import Component_Model from  '@/nextts/model/Component_Model';
import Http_Interface from '@/nextts/play/Http_Interface';
import Play_Interface from '@/nextts/play/Play_Interface';
import gsap from "gsap";
import Content_Model from '@/nextts/model/Content_Model';
import { useContentStore } from "@/stores/content";
import { emitter } from '@/emitter';
import Play_Sound from './Play_Sound';

class Play_Shape extends HTMLElement implements Http_Interface, Play_Interface{
    
    model:Component_Model|null = null;
    timeline:null|GSAPTimeline = null;

    contentStore = useContentStore();
    private updateShapeHandler:any;
    private updateShapeClickHandler:any;
    private updateShapeTouchHandler:any;

    constructor(m:Component_Model){
        super();
        this.model = m;
        this.style.position = "absolute";
    }
    
    init(): void {

        if(this.model?.showlock){
            return;
        }

        if(this.model != null && this.model.api_use){
            this.updateShapeHandler = this.updateshape_handler.bind(this);
            emitter.on('updatetext', this.updateShapeHandler);
        }

        if(this.model?.event_use){
            if(this.model.event_type >= 1){
                this.updateShapeClickHandler = this.handleClick.bind(this);
                this.updateShapeTouchHandler = this.handleTouchStart.bind(this);
                this.addEventListener('click',      this.updateShapeClickHandler);
                this.addEventListener('touchstart', this.updateShapeTouchHandler);                
            }
        }

        this.playAni();
    }

    handleClick(event: MouseEvent){
        this.clickevent();
    }
    
    handleTouchStart(event: TouchEvent){
        this.clickevent();
    }    

    clickevent(){
        if(this.model?.event_type == 1){
            for(let i=0; i < this.contentStore.content_model.screen_list.length; i++){
                const screen= this.contentStore.content_model.screen_list[i];
                if(this.model.event_move == screen.screen_name){
                    emitter.emit('movepage', i);
                    break;
                }
            }
        }else if(this.model?.event_type == 2){
            if(this.contentStore.select_screen == null) return;
            for(let i=0; i < this.contentStore.select_screen?.component_list.length; i++){
                const component = this.contentStore.select_screen.component_list[i];
                if(component.component_type == Component_Model.COMPONENT_API && this.model.event_api == component.apiname){
                    const api_component = component.play_component as any;
                    api_component.runApiAwait();
                    break;
                }
            }
        }else if(this.model?.event_type == 20){
            if(this.contentStore.select_screen == null) return;
            for(let i=0; i < this.contentStore.select_screen?.component_list.length; i++){
                const component = this.contentStore.select_screen.component_list[i];
                if(component.component_type == Component_Model.COMPONENT_SOUND && this.model.event_input_target == component.event_name){
                    const api_component = component.play_component as Play_Sound;
                    api_component.soundplayevent();
                    break;
                }
            }
        }        
    }

    async updateshape_handler(){
        // API 연동 시 Shape 속성 업데이트 로직 추가 가능
    }

    exit(): void {
        gsap.killTweensOf(this);

        if(this.model != null && this.model.api_use){
            emitter.off('updatetext', this.updateShapeHandler);
        }
        
        if(this.model?.event_use){
            if(this.model.event_type >= 1){
                this.removeEventListener('click',       this.updateShapeClickHandler);
                this.removeEventListener('touchstart',  this.updateShapeTouchHandler);                
            }
        }

        if(this.timeline != null){
            this.timeline.kill();
            this.timeline.clear();
            this.timeline = null;
        }

        if(this.model != null){
            this.model.play_component = null;
        }
    }

    playAni(){
        if(this.model == null) return;

        if(this.model.aniplaymodel != null && this.model.aniplaymodel.anilist != null && this.model.aniplaymodel.anilist.length > 0){
            setTimeout(() => {
                this.drawView();
                this.runAni();
            }, Number(this.model.aniplaymodel.anilist[0].delay) * 1000);
        }else{
            this.drawView();
        }
    }

    runAni(){
        if(this.model == null) return;

        if(this.timeline != null){
            this.timeline.kill();
            this.timeline.clear();
            this.timeline = null;
        }
        this.timeline = gsap.timeline({repeat:Number(this.model.aniplaymodel.repeat), repeatDelay:Number(this.model.aniplaymodel.repeatDelay), yoyo:Boolean(this.model.aniplaymodel.yoyo)});

        let move_posx   = Number(this.model.transx);
        let move_posy   = Number(this.model.transy);
        let move_rotate = Number(this.model.rotate);
        
        let move_rotatex = 0;
        let move_rotatey = 0;
        let move_skewx   = 0;
        let move_skewy   = 0;

        this.model.aniplaymodel.anilist.forEach((ani, index)=>{
            move_posx += Number(ani.movex);
            move_posy += Number(ani.movey);
            move_rotate += Number(ani.rotate);
            move_rotatex += Number(ani.rotatex);
            move_rotatey += Number(ani.rotatey);
            move_skewx += Number(ani.skewx);
            move_skewy += Number(ani.skewy);
            
            const aniprop: {[key: string]: string|number|boolean} = { delay: ani.delay, duration:ani.duration, x:move_posx, y:move_posy
                                                            , scaleX:ani.scalex, scaleY:ani.scaley
                                                            , rotationX:move_rotatex, rotationY:move_rotatey, rotation:move_rotate
                                                            , skewX:move_skewx, skewY:move_skewy        
                                                            , alpha:ani.alpha, ease:`${ani.ease}.${ani.easetype}` 
                                                            , transformOrigin: `${ani.centerx}% ${ani.centery}%`
                                                            , force3D: true, willChange: "transform"};
            ani.proplist.forEach(prop=>{
                aniprop[prop.propname] = prop.propvalue;
            });
            this.timeline!.to(this, aniprop);
        });        
    }

    async drawView(){
        if(this.model == null || this.model == undefined){
            return;
        }

        this.style.backgroundColor  = "#00000000";
        this.style.width  = this.model.width+"px";
        this.style.height = this.model.height+"px";
        this.style.opacity = String(this.model.opacity);
        
        const hasSeparateRadius = this.model.border_radius_tl > 0 || 
                                this.model.border_radius_tr > 0 || 
                                this.model.border_radius_bl > 0 || 
                                this.model.border_radius_br > 0;
        
        if (hasSeparateRadius) {
            this.style.borderRadius = `${this.model.border_radius_tl}px ${this.model.border_radius_tr}px ${this.model.border_radius_br}px ${this.model.border_radius_bl}px`;
        } else {
            this.style.borderRadius = `${this.model.border_radius}px`;
        }

        //shadow 처리
        if(this.model.shadow_use){
            this.style.filter = `drop-shadow(${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color})`;
        }else{
            this.style.filter = "";
        }

        this.createShape();
        
        this.style.transform = `translateX(${this.model.transx}px) translateY(${this.model.transy}px) rotate(${this.model.rotate}deg)`;
    }

    createShape(){
        if(!this.model) return;

        // 모든 경우를 SVG로 처리하여 테두리, 모서리 둥글기 등 지원
        const svgContent = this.generateShapeSVG();
        this.innerHTML = svgContent;
        
        // HTML 스타일 초기화
        this.style.background = '';
        this.style.clipPath = '';
        this.style.opacity = '';
    }
    
    // Shape 모양에 따른 clip-path 적용
    applyShapeClipPath() {
        if(!this.model) return;
        
        const shapeType = this.model.shape_type || "rectangle";
        
        switch(shapeType) {
            case "rectangle":
                // 모서리 둥글기 적용
                const radius = this.model.shape_corner_radius || 0;
                this.style.borderRadius = `${radius}px`;
                this.style.clipPath = '';
                break;
                
            case "circle":
                this.style.clipPath = 'ellipse(50% 50% at 50% 50%)';
                this.style.borderRadius = '';
                break;
                
            case "triangle":
                this.style.clipPath = 'polygon(50% 0%, 0% 100%, 100% 100%)';
                this.style.borderRadius = '';
                break;
                
            default:
                this.style.clipPath = '';
                this.style.borderRadius = '';
        }
    }

    generateShapeSVG(): string {
        if(!this.model) return "";

        const width = this.model.width;
        const height = this.model.height;
        const fillType = this.model.shape_fill_type || "color";
        const fillColor = this.model.shape_fill_color || "#3B82F6";
        const fillImage = this.model.shape_fill_image || "";
        const fillAlpha = this.model.shape_fill_alpha !== undefined ? this.model.shape_fill_alpha : 1.0;
        const strokeColor = this.model.shape_stroke_color || "#1E40AF";
        const strokeAlpha = this.model.shape_stroke_alpha !== undefined ? this.model.shape_stroke_alpha : 1.0;
        const strokeWidth = this.model.shape_stroke_width || 0;

        // RGBA 색상 생성 함수
        const hexToRgba = (hex: string, alpha: number): string => {
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        };

        // Fill 설정 - 색상, 그라데이션, 이미지
        let finalFillColor: string;
        let defsContent = "";
        
        if (fillType === "image" && fillImage) {
            const patternId = this.generateUniqueId('image-pattern');
            const imageFit = this.model.shape_image_fit || "cover";
            const imagePositionX = this.model.shape_image_position_x !== undefined ? this.model.shape_image_position_x : 50;
            const imagePositionY = this.model.shape_image_position_y !== undefined ? this.model.shape_image_position_y : 50;
            const imageScale = this.model.shape_image_scale !== undefined ? this.model.shape_image_scale : 100;
            const imageRepeat = this.model.shape_image_repeat || false;

            // 이미지 크기 및 위치 계산
            const scaleRatio = imageScale / 100;
            const imageWidth = width * scaleRatio;
            const imageHeight = height * scaleRatio;
            const imageX = (width - imageWidth) * (imagePositionX / 100);
            const imageY = (height - imageHeight) * (imagePositionY / 100);

            // preserveAspectRatio 설정
            let preserveAspectRatio = "xMidYMid slice";
            switch(imageFit) {
                case "cover":
                    preserveAspectRatio = "xMidYMid slice";
                    break;
                case "contain":
                    preserveAspectRatio = "xMidYMid meet";
                    break;
                case "fill":
                    preserveAspectRatio = "none";
                    break;
                case "none":
                    preserveAspectRatio = "none";
                    break;
            }

            // 패턴 크기 설정 (반복용)
            const patternWidth = imageRepeat ? (imageWidth / width) : 1;
            const patternHeight = imageRepeat ? (imageHeight / height) : 1;

            defsContent = `<defs>
                <pattern id="${patternId}" patternUnits="objectBoundingBox" 
                         width="${patternWidth}" height="${patternHeight}">
                    <image href="${fillImage}" 
                           x="${imageX}" y="${imageY}" 
                           width="${imageWidth}" height="${imageHeight}" 
                           preserveAspectRatio="${preserveAspectRatio}" 
                           opacity="${fillAlpha}"/>
                </pattern>
            </defs>`;
            finalFillColor = `url(#${patternId})`;
        } else if (fillType === "gradient") {
            // CSS 그라데이션을 SVG 그라데이션으로 변환
            const gradientId = this.generateUniqueId('gradient');
            const parsedGradient = this.parseCSSGradient(fillColor);
            
            if (parsedGradient) {
                const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                let gradientAttrs = '';
                
                if (parsedGradient.type === 'radial') {
                    gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                } else {
                    // 선형 그라데이션 각도 처리
                    const angle = parsedGradient.angle || 180;
                    const radians = ((angle - 90) * Math.PI) / 180;
                    const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                    const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                    const x2 = 50 + 50 * Math.cos(radians);
                    const y2 = 50 + 50 * Math.sin(radians);
                    gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                }
                
                let gradientStops = '';
                parsedGradient.stops.forEach(stop => {
                    gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}" stop-opacity="${fillAlpha}"/>`;
                });
                
                defsContent = `<defs>
                    <${gradientType} id="${gradientId}" ${gradientAttrs} gradientUnits="userSpaceOnUse">
                        ${gradientStops}
                    </${gradientType}>
                </defs>`;
                finalFillColor = `url(#${gradientId})`;
            } else {
                finalFillColor = hexToRgba(fillColor, fillAlpha);
            }
        } else {
            // 일반 색상 처리 - alpha 값 적용
            if (typeof fillColor === 'string' && fillColor.startsWith('#') && fillColor.length === 9) {
                // 8자리 hex 색상 (alpha 포함)
                const r = parseInt(fillColor.slice(1, 3), 16) || 0;
                const g = parseInt(fillColor.slice(3, 5), 16) || 0;
                const b = parseInt(fillColor.slice(5, 7), 16) || 0;
                const a = parseInt(fillColor.slice(7, 9), 16) / 255;
                finalFillColor = `rgba(${r}, ${g}, ${b}, ${a})`;
            } else {
                finalFillColor = hexToRgba(fillColor, fillAlpha);
            }
        }
        
        // 테두리 색상 처리 (단색/그라데이션)
        let finalStrokeColor = 'none';
        if (strokeWidth > 0) {
            const strokeType = this.model.shape_stroke_type || "color";
            
            if (strokeType === "gradient") {
                // 그라데이션 처리
                const gradientId = this.generateUniqueId('stroke-gradient');
                const parsedGradient = this.parseCSSGradient(strokeColor);
                
                if (parsedGradient) {
                    const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                    let gradientAttrs = '';
                    
                    if (parsedGradient.type === 'radial') {
                        gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                    } else {
                        // 선형 그라데이션 각도 처리
                        const angle = parsedGradient.angle || 180;
                        const radians = ((angle - 90) * Math.PI) / 180;
                        const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                        const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                        const x2 = 50 + 50 * Math.cos(radians);
                        const y2 = 50 + 50 * Math.sin(radians);
                        gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                    }
                    
                    let gradientStops = '';
                    parsedGradient.stops.forEach(stop => {
                        gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}"/>`;
                    });
                    
                    const strokeGradientDef = `<${gradientType} id="${gradientId}" ${gradientAttrs} gradientUnits="userSpaceOnUse">
                        ${gradientStops}
                    </${gradientType}>`;
                    
                    // 기존 defsContent에 추가
                    if (defsContent.includes('<defs>')) {
                        defsContent = defsContent.replace('</defs>', `${strokeGradientDef}</defs>`);
                    } else {
                        defsContent = `<defs>${strokeGradientDef}</defs>`;
                    }
                    
                    finalStrokeColor = `url(#${gradientId})`;
                } else {
                    finalStrokeColor = hexToRgba(strokeColor, strokeAlpha);
                }
            } else {
                finalStrokeColor = strokeColor;
            }
        }

        let shapeElement = "";
        const strokeOpacityAttr = this.model.shape_stroke_type === "gradient" ? "" : ` stroke-opacity="${strokeAlpha}"`;
        
        switch(this.model.shape_type) {
            case "rectangle":
                const rectWidth = Math.max(0, width - strokeWidth);
                const rectHeight = Math.max(0, height - strokeWidth);
                
                // 각 모서리별 둥글기 체크
                const baseRadius = this.model.shape_corner_radius || 0;
                const tl = this.model.shape_corner_radius_tl !== undefined ? this.model.shape_corner_radius_tl : baseRadius;
                const tr = this.model.shape_corner_radius_tr !== undefined ? this.model.shape_corner_radius_tr : baseRadius;
                const bl = this.model.shape_corner_radius_bl !== undefined ? this.model.shape_corner_radius_bl : baseRadius;
                const br = this.model.shape_corner_radius_br !== undefined ? this.model.shape_corner_radius_br : baseRadius;
                
                const hasSeparateRadius = tl > 0 || tr > 0 || bl > 0 || br > 0;
                
                if (hasSeparateRadius) {
                    // path를 사용해서 각 모서리별 둥글기 적용
                    const pathData = this.generateRectanglePath(strokeWidth/2, strokeWidth/2, rectWidth, rectHeight, tl, tr, bl, br);
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                } else {
                    // 기본 rect 사용 (호환성)
                    const rx = this.model.shape_corner_radius || 0;
                    shapeElement = `<rect x="${strokeWidth/2}" y="${strokeWidth/2}" 
                                        width="${rectWidth}" height="${rectHeight}" 
                                        rx="${rx}" ry="${rx}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                }
                break;
                
            case "circle":
                // 타원(Ellipse) - 너비와 높이에 맞춰 그리기
                const radiusX = Math.max(0, (width - strokeWidth) / 2);
                const radiusY = Math.max(0, (height - strokeWidth) / 2);
                const cx = width / 2;
                const cy = height / 2;
                
                // 원 제어 속성 기본값 설정
                const startAngle = this.model.circle_start_angle !== undefined ? this.model.circle_start_angle : 0;
                const endAngle = this.model.circle_end_angle !== undefined ? this.model.circle_end_angle : 360;
                const innerRadiusRatio = this.model.circle_inner_radius !== undefined ? this.model.circle_inner_radius : 0;
                
                // 완전한 타원인지 확인
                const isFullEllipse = (endAngle - startAngle) % 360 === 0;
                const isDonut = innerRadiusRatio > 0;
                
                if (isFullEllipse && !isDonut) {
                    // 기본 완전한 타원 (ellipse 태그 사용)
                    shapeElement = `<ellipse cx="${cx}" cy="${cy}" rx="${radiusX}" ry="${radiusY}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                } else {
                    // Arc, Pie, Donut을 위한 path 생성 (타원 기준)
                    const pathData = this.generateEllipsePath(cx, cy, radiusX, radiusY, startAngle, endAngle, innerRadiusRatio);
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                }
                break;
                
            case "polygon":
                const sides = this.model.polygon_sides || 5;
                const cornerRadius = this.model.polygon_corner_radius || 0;
                const innerRadius = this.model.polygon_inner_radius || 0;
                
                if (cornerRadius > 0) {
                    // 모서리 둥글기가 있는 경우 path 사용
                    const pathData = this.generatePolygonPath(width, height, sides, strokeWidth, cornerRadius, innerRadius);
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                } else {
                    // 기본 polygon 사용
                    const polygonPoints = this.generatePolygonPoints(width, height, sides, strokeWidth, innerRadius);
                    shapeElement = `<polygon points="${polygonPoints}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                }
                break;
                
            case "line":
                // 선 그리기
                const lineThickness = this.model.line_thickness || 2;
                const lineColorType = this.model.line_color_type || "color";
                const lineColor = this.model.line_color || "#000000";
                const lineAlpha = this.model.line_alpha !== undefined ? this.model.line_alpha : 1.0;
                const startCap = this.model.line_start_cap || "round";
                const endCap = this.model.line_end_cap || "round";
                
                let finalLineColor: string;
                
                if (lineColorType === "gradient") {
                    // 그라데이션 처리
                    const gradientId = this.generateUniqueId('gradient');
                    const parsedGradient = this.parseCSSGradient(lineColor);
                    
                    if (parsedGradient) {
                        const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                        let gradientAttrs = '';
                        
                        if (parsedGradient.type === 'radial') {
                            gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                        } else {
                            // 선형 그라데이션 각도 처리
                            const angle = parsedGradient.angle || 180;
                            const radians = ((angle - 90) * Math.PI) / 180;
                            const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                            const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                            const x2 = 50 + 50 * Math.cos(radians);
                            const y2 = 50 + 50 * Math.sin(radians);
                            gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                        }
                        
                        let gradientStops = '';
                        parsedGradient.stops.forEach(stop => {
                            gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}"/>`;
                        });
                        
                        defsContent = `<defs>
                            <${gradientType} id="${gradientId}" ${gradientAttrs} gradientUnits="userSpaceOnUse">
                                ${gradientStops}
                            </${gradientType}>
                        </defs>`;
                        finalLineColor = `url(#${gradientId})`;
                    } else {
                        finalLineColor = lineColor;
                    }
                } else {
                    finalLineColor = lineColor;
                }
                
                // 선의 시작점과 끝점 (컴포넌트 영역 전체를 가로지르는 수평선)
                const x1 = lineThickness / 2;
                const y1 = height / 2;
                const x2 = width - lineThickness / 2;
                const y2 = height / 2;
                
                // 그라데이션일 때는 opacity 없이, 단색일 때는 opacity 적용
                const opacityAttr = lineColorType === "gradient" ? "" : ` opacity="${lineAlpha}"`;
                
                // 시작점과 끝점이 같으면 기본 line 엘리먼트 사용
                if (startCap === endCap) {
                    shapeElement = `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"
                                        stroke="${finalLineColor}"
                                        stroke-width="${lineThickness}"
                                        stroke-linecap="${startCap}"${opacityAttr}/>`;
                } else {
                    // 시작점과 끝점이 다르면 path로 그리기
                    const halfThickness = lineThickness / 2;
                    
                    // 기본 라인 경로
                    let pathData = `M ${x1} ${y1} L ${x2} ${y2}`;
                    
                    // 시작점 캡 추가
                    if (startCap === "round") {
                        pathData = `M ${x1} ${y1 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x1} ${y1 + halfThickness} L ${x1} ${y1} L ${x2} ${y2}`;
                    }
                    
                    // 끝점 캡 추가
                    if (endCap === "round") {
                        if (startCap === "round") {
                            pathData = `M ${x1} ${y1 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x1} ${y1 + halfThickness} L ${x2} ${y2 + halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x2} ${y2 - halfThickness} L ${x1} ${y1 - halfThickness} Z`;
                        } else {
                            pathData = `M ${x1} ${y1 - halfThickness} L ${x2} ${y2 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x2} ${y2 + halfThickness} L ${x1} ${y1 + halfThickness} Z`;
                        }
                    } else {
                        // butt 끝점인 경우
                        if (startCap === "round") {
                            pathData = `M ${x1} ${y1 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x1} ${y1 + halfThickness} L ${x2} ${y2 + halfThickness} L ${x2} ${y2 - halfThickness} Z`;
                        } else {
                            // 둘 다 butt인 경우는 위에서 처리됨
                            pathData = `M ${x1} ${y1 - halfThickness} L ${x2} ${y2 - halfThickness} L ${x2} ${y2 + halfThickness} L ${x1} ${y1 + halfThickness} Z`;
                        }
                    }
                    
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalLineColor}"${opacityAttr}/>`;
                }
                break;
                
            default:
                // 기본값은 사각형
                const defaultWidth = Math.max(0, width - strokeWidth);
                const defaultHeight = Math.max(0, height - strokeWidth);
                shapeElement = `<rect x="${strokeWidth/2}" y="${strokeWidth/2}" 
                                    width="${defaultWidth}" height="${defaultHeight}" 
                                    fill="${finalFillColor}" 
                                    stroke="${finalStrokeColor}" 
                                    stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
        }

        // ⚠ style="display:block" 필수 — SVG default 는 inline 이라 부모 baseline 영향으로 height 작을 때 위치가 어긋남
        return `<svg xmlns="http://www.w3.org/2000/svg"
                    width="100%" height="100%"
                    viewBox="0 0 ${width} ${height}"
                    style="display:block;">
                    ${defsContent}
                    ${shapeElement}
                </svg>`;
    }

    // 타원의 Arc, Pie, Donut path 생성 - 피그마 스타일
    generateEllipsePath(cx: number, cy: number, radiusX: number, radiusY: number, startAngle: number, endAngle: number, innerRadiusRatio: number): string {
        // 각도를 라디안으로 변환 (SVG는 12시 방향이 -90도)
        const startRad = ((startAngle - 90) * Math.PI) / 180;
        const endRad = ((endAngle - 90) * Math.PI) / 180;
        
        // 외부 타원의 시작점과 끝점
        const x1 = cx + radiusX * Math.cos(startRad);
        const y1 = cy + radiusY * Math.sin(startRad);
        const x2 = cx + radiusX * Math.cos(endRad);
        const y2 = cy + radiusY * Math.sin(endRad);
        
        // 호의 각도가 180도보다 큰지 확인
        const largeArcFlag = (endAngle - startAngle) % 360 > 180 ? 1 : 0;
        
        let pathData = "";
        
        if (innerRadiusRatio > 0) {
            // Donut 모양 (타원형)
            const innerRadiusX = radiusX * innerRadiusRatio;
            const innerRadiusY = radiusY * innerRadiusRatio;
            const ix1 = cx + innerRadiusX * Math.cos(startRad);
            const iy1 = cy + innerRadiusY * Math.sin(startRad);
            const ix2 = cx + innerRadiusX * Math.cos(endRad);
            const iy2 = cy + innerRadiusY * Math.sin(endRad);
            
            if ((endAngle - startAngle) % 360 === 0) {
                // 완전한 타원형 도넛
                pathData = `M ${cx + radiusX} ${cy} 
                           A ${radiusX} ${radiusY} 0 1 1 ${cx - radiusX} ${cy}
                           A ${radiusX} ${radiusY} 0 1 1 ${cx + radiusX} ${cy}
                           Z
                           M ${cx + innerRadiusX} ${cy}
                           A ${innerRadiusX} ${innerRadiusY} 0 1 0 ${cx - innerRadiusX} ${cy}
                           A ${innerRadiusX} ${innerRadiusY} 0 1 0 ${cx + innerRadiusX} ${cy}
                           Z`;
            } else {
                // 부채꼴 타원형 도넛
                pathData = `M ${x1} ${y1}
                           A ${radiusX} ${radiusY} 0 ${largeArcFlag} 1 ${x2} ${y2}
                           L ${ix2} ${iy2}
                           A ${innerRadiusX} ${innerRadiusY} 0 ${largeArcFlag} 0 ${ix1} ${iy1}
                           Z`;
            }
        } else {
            // Arc 또는 Pie (타원형)
            if ((endAngle - startAngle) % 360 === 0) {
                // 완전한 타원 (이 경우는 위에서 처리되지만 안전장치)
                pathData = `M ${cx + radiusX} ${cy} 
                           A ${radiusX} ${radiusY} 0 1 1 ${cx - radiusX} ${cy}
                           A ${radiusX} ${radiusY} 0 1 1 ${cx + radiusX} ${cy}
                           Z`;
            } else {
                // Pie 모양 (중심에서 시작, 타원형)
                pathData = `M ${cx} ${cy}
                           L ${x1} ${y1}
                           A ${radiusX} ${radiusY} 0 ${largeArcFlag} 1 ${x2} ${y2}
                           Z`;
            }
        }
        
        return pathData;
    }

    // 다각형/별 좌표 생성 메서드 (내부 반지름 지원)
    generatePolygonPoints(width: number, height: number, sides: number, strokeWidth: number, innerRadius: number = 0): string {
        const centerX = width / 2;
        const centerY = height / 2;
        
        // Shape 영역에 완전히 fit하도록 반지름 계산
        const availableWidth = width - strokeWidth;
        const availableHeight = height - strokeWidth;
        
        // 다각형이 완전히 들어갈 수 있는 최대 반지름 계산
        let maxRadiusX = availableWidth / 2;
        let maxRadiusY = availableHeight / 2;
        
        // 삼각형의 경우 특별 처리 - 정삼각형이 영역에 완전히 fit하도록
        if (sides === 3) {
            // 정삼각형의 높이는 (밑변 * √3) / 2
            // 영역에 fit하려면: 높이 = availableHeight, 밑변 = availableWidth
            // 반지름은 밑변의 1/3 (외접원의 반지름)
            const maxRadiusByHeight = (availableHeight * 2) / 3; // 높이 기준 반지름
            const maxRadiusByWidth = availableWidth / 2; // 너비 기준 반지름
            
            // 둘 중 작은 값 사용하여 영역을 벗어나지 않도록
            const fitRadius = Math.min(maxRadiusByHeight, maxRadiusByWidth);
            maxRadiusX = fitRadius;
            maxRadiusY = fitRadius;
        }
        
        const outerRadiusX = Math.max(0, maxRadiusX);
        const outerRadiusY = Math.max(0, maxRadiusY);
        const innerRadiusX = outerRadiusX * innerRadius;
        const innerRadiusY = outerRadiusY * innerRadius;
        
        const points: string[] = [];
        
        if (innerRadius > 0 && innerRadius !== undefined && innerRadius !== null) {
            // 별 모양: 외부 꼭짓점과 내부 꼭짓점 번갈아가며 생성
            for (let i = 0; i < sides * 2; i++) {
                const angle = (i * Math.PI / sides) - (Math.PI / 2); // -90도 회전 (12시 방향 시작)
                const isOuter = i % 2 === 0;
                const radiusX = isOuter ? outerRadiusX : innerRadiusX;
                const radiusY = isOuter ? outerRadiusY : innerRadiusY;
                const x = centerX + radiusX * Math.cos(angle);
                const y = centerY + radiusY * Math.sin(angle);
                points.push(`${x.toFixed(2)},${y.toFixed(2)}`);
            }
        } else {
            // 기본 다각형: 외부 꼭짓점만
            for (let i = 0; i < sides; i++) {
                const angle = (i * 2 * Math.PI / sides) - (Math.PI / 2); // -90도 회전 (12시 방향 시작)
                const x = centerX + outerRadiusX * Math.cos(angle);
                const y = centerY + outerRadiusY * Math.sin(angle);
                points.push(`${x.toFixed(2)},${y.toFixed(2)}`);
            }
        }
        
        return points.join(' ');
    }

    // 모서리 둥글기가 적용된 다각형/별 path 생성
    generatePolygonPath(width: number, height: number, sides: number, strokeWidth: number, cornerRadius: number, innerRadius: number = 0): string {
        const centerX = width / 2;
        const centerY = height / 2;
        
        // Shape 영역에 완전히 fit하도록 반지름 계산
        const availableWidth = width - strokeWidth;
        const availableHeight = height - strokeWidth;
        
        // 다각형이 완전히 들어갈 수 있는 최대 반지름 계산
        let maxRadiusX = availableWidth / 2;
        let maxRadiusY = availableHeight / 2;
        
        // 삼각형의 경우 특별 처리 - 정삼각형이 영역에 완전히 fit하도록
        if (sides === 3) {
            // 정삼각형의 높이는 (밑변 * √3) / 2
            // 영역에 fit하려면: 높이 = availableHeight, 밑변 = availableWidth
            // 반지름은 밑변의 1/3 (외접원의 반지름)
            const maxRadiusByHeight = (availableHeight * 2) / 3; // 높이 기준 반지름
            const maxRadiusByWidth = availableWidth / 2; // 너비 기준 반지름
            
            // 둘 중 작은 값 사용하여 영역을 벗어나지 않도록
            const fitRadius = Math.min(maxRadiusByHeight, maxRadiusByWidth);
            maxRadiusX = fitRadius;
            maxRadiusY = fitRadius;
        }
        
        const outerRadiusX = Math.max(0, maxRadiusX);
        const outerRadiusY = Math.max(0, maxRadiusY);
        const innerRadiusX = outerRadiusX * innerRadius;
        const innerRadiusY = outerRadiusY * innerRadius;
        
        const vertices: {x: number, y: number}[] = [];
        
        if (innerRadius > 0 && innerRadius !== undefined && innerRadius !== null) {
            // 별 모양: 외부 꼭짓점과 내부 꼭짓점 번갈아가며 생성
            for (let i = 0; i < sides * 2; i++) {
                const angle = (i * Math.PI / sides) - (Math.PI / 2);
                const isOuter = i % 2 === 0;
                const radiusX = isOuter ? outerRadiusX : innerRadiusX;
                const radiusY = isOuter ? outerRadiusY : innerRadiusY;
                const x = centerX + radiusX * Math.cos(angle);
                const y = centerY + radiusY * Math.sin(angle);
                vertices.push({x, y});
            }
        } else {
            // 기본 다각형: 외부 꼭짓점만
            for (let i = 0; i < sides; i++) {
                const angle = (i * 2 * Math.PI / sides) - (Math.PI / 2);
                const x = centerX + outerRadiusX * Math.cos(angle);
                const y = centerY + outerRadiusY * Math.sin(angle);
                vertices.push({x, y});
            }
        }
        
        if (vertices.length < 3) return "";
        
        let pathData = "";
        
        for (let i = 0; i < vertices.length; i++) {
            const current = vertices[i];
            const next = vertices[(i + 1) % vertices.length];
            const prev = vertices[(i - 1 + vertices.length) % vertices.length];
            
            // 벡터 계산
            const dx1 = current.x - prev.x;
            const dy1 = current.y - prev.y;
            const dx2 = next.x - current.x;
            const dy2 = next.y - current.y;
            
            // 벡터 길이
            const len1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
            const len2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
            
            if (len1 === 0 || len2 === 0) continue;
            
            // 단위 벡터
            const ux1 = dx1 / len1;
            const uy1 = dy1 / len1;
            const ux2 = dx2 / len2;
            const uy2 = dy2 / len2;
            
            // 모서리 둥글기 적용 거리 계산
            const maxRadius = Math.min(len1, len2) / 2;
            const actualRadius = Math.min(cornerRadius, maxRadius);
            
            // 둥글기 시작/끝점
            const startX = current.x - ux1 * actualRadius;
            const startY = current.y - uy1 * actualRadius;
            const endX = current.x + ux2 * actualRadius;
            const endY = current.y + uy2 * actualRadius;
            
            if (i === 0) {
                pathData += `M ${startX.toFixed(2)} ${startY.toFixed(2)}`;
            } else {
                pathData += ` L ${startX.toFixed(2)} ${startY.toFixed(2)}`;
            }
            
            if (actualRadius > 0) {
                pathData += ` Q ${current.x.toFixed(2)} ${current.y.toFixed(2)} ${endX.toFixed(2)} ${endY.toFixed(2)}`;
            }
        }
        
        pathData += " Z";
        return pathData;
    }

    // 각 모서리별 둥글기가 적용된 사각형 path 생성
    generateRectanglePath(x: number, y: number, width: number, height: number, tl: number, tr: number, bl: number, br: number): string {
        // 모서리 둥글기가 너무 크면 제한
        const maxRadius = Math.min(width, height) / 2;
        tl = Math.min(tl, maxRadius);
        tr = Math.min(tr, maxRadius);
        bl = Math.min(bl, maxRadius);
        br = Math.min(br, maxRadius);

        return `M ${x + tl},${y}
                L ${x + width - tr},${y}
                ${tr > 0 ? `Q ${x + width},${y} ${x + width},${y + tr}` : `L ${x + width},${y}`}
                L ${x + width},${y + height - br}
                ${br > 0 ? `Q ${x + width},${y + height} ${x + width - br},${y + height}` : `L ${x + width},${y + height}`}
                L ${x + bl},${y + height}
                ${bl > 0 ? `Q ${x},${y + height} ${x},${y + height - bl}` : `L ${x},${y + height}`}
                L ${x},${y + tl}
                ${tl > 0 ? `Q ${x},${y} ${x + tl},${y}` : `L ${x},${y}`}
                Z`;
    }

    resultHttp(a_id:number, result:string, obj:object){
        
    }

    // CSS 그라데이션 문자열을 파싱하는 메서드
    parseCSSGradient(cssGradient: string): { type: string, angle?: number, stops: Array<{color: string, position: number}> } | null {
        try {
            // linear-gradient 또는 radial-gradient 추출
            const isRadial = cssGradient.includes('radial-gradient');
            const type = isRadial ? 'radial' : 'linear';
            
            // 괄호 안의 내용 추출
            const match = cssGradient.match(/(?:linear|radial)-gradient\((.+)\)$/);
            if (!match) return null;
            
            const content = match[1];
            
            // 색상 stop들을 정확하게 분리하기 위해 더 정교한 방법 사용
            const colorStops: Array<{color: string, position: number}> = [];
            let angle = 180;
            
            // 각도 추출 (Ndeg 또는 CSS 키워드 방향 to right/to bottom 등)
            const angleMatch = content.match(/(-?[\d.]+)deg/);
            if (angleMatch) {
                angle = parseFloat(angleMatch[1]);
            } else {
                const dirMatch = content.match(/to\s+(top|bottom|left|right)(?:\s+(top|bottom|left|right))?/i);
                if (dirMatch) {
                    const dirs = [dirMatch[1], dirMatch[2]].filter(Boolean).map(d => d.toLowerCase());
                    const cardinal: Record<string, number> = { top: 0, right: 90, bottom: 180, left: 270 };
                    if (dirs.length === 1) {
                        angle = cardinal[dirs[0]];
                    } else {
                        const has = (d: string) => dirs.indexOf(d) !== -1;
                        if (has('top') && has('right')) angle = 45;
                        else if (has('bottom') && has('right')) angle = 135;
                        else if (has('bottom') && has('left')) angle = 225;
                        else if (has('top') && has('left')) angle = 315;
                    }
                }
            }
            
            // HEX 색상 stop 추출 - #RRGGBB position% 또는 #RRGGBBAA position% 형태
            const hexMatches = content.matchAll(/#([0-9a-fA-F]{6}([0-9a-fA-F]{2})?)\s*(\d+)%/g);
            for (const match of hexMatches) {
                const hex = match[1];
                const position = parseInt(match[3]);
                
                // HEX를 RGB/RGBA로 변환
                let color: string;
                if (hex.length === 8) {
                    // 8자리 HEX (RRGGBBAA)
                    const r = parseInt(hex.slice(0, 2), 16);
                    const g = parseInt(hex.slice(2, 4), 16);
                    const b = parseInt(hex.slice(4, 6), 16);
                    const a = parseInt(hex.slice(6, 8), 16) / 255;
                    color = `rgba(${r}, ${g}, ${b}, ${a})`;
                } else {
                    // 6자리 HEX (RRGGBB)
                    const r = parseInt(hex.slice(0, 2), 16);
                    const g = parseInt(hex.slice(2, 4), 16);
                    const b = parseInt(hex.slice(4, 6), 16);
                    color = `rgb(${r}, ${g}, ${b})`;
                }
                
                colorStops.push({
                    color: color,
                    position: position
                });
            }
            
            // RGB/RGBA 색상 stop 추출 - rgba(r, g, b, a) position% 또는 rgb(r, g, b) position% 형태
            const colorMatches = content.matchAll(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+))?\s*\)\s*(\d+)%/g);
            for (const match of colorMatches) {
                const r = match[1];
                const g = match[2];
                const b = match[3];
                const a = match[4]; // 알파값 (없을 수도 있음)
                const position = parseInt(match[5]);
                
                const color = a !== undefined ? `rgba(${r}, ${g}, ${b}, ${a})` : `rgb(${r}, ${g}, ${b})`;
                colorStops.push({
                    color: color,
                    position: position
                });
            }
            
            return { type, angle, stops: colorStops };
        } catch (error) {
            console.error('CSS gradient parsing error:', error);
            return null;
        }
    }

    // 유니크한 ID 생성 함수
    generateUniqueId(prefix: string = 'id'): string {
        const timestamp = Date.now();
        const random = Math.random().toString(36).substr(2, 9);
        const componentHash = this.model ? `${this.model.component_type}-${this.model.posx}-${this.model.posy}` : 'unknown';
        return `${prefix}-${componentHash}-${timestamp}-${random}`;
    }

    disconnectedCallback(): void {
        this.exit();
    }
}

export default Play_Shape
customElements.define('play-shape', Play_Shape);